const rarityPercents: Record<string, string> = {
    'consumer-grade': "79.92%",
    'industrial-grade': "15.98%",
    'mil-spec': "3.2%",
    "restricted": "0.64%",
    "classified": "0.26%",
    "covert": "0.64%",
    "covert-knives-or-gloves": "0.26%",
    "exceedingly-rare": "<0.01%",
    "contraband": "N/A"

}

export default function (rarity: string, category?: string) {
    if (!rarity) {
        return ''
    }
    category = category?.toLowerCase()
    const modifiedRarity = getModifiedString(rarity)
    if (rarity === 'covert' && category && (category.includes('gloves') || category.includes('knives'))) {
        return rarityPercents[`${modifiedRarity}-knives-or-gloves`]
    }

    return rarityPercents[modifiedRarity]
}
